import React, { useState, useCallback, Fragment, useContext } from 'react'//,{useState,useCallback}
import styles from './CallBackSettings.module.css'
// import { DropdownButton, Dropdown, Button } from 'react-bootstrap'
// import * as loginReq from '../../../../axios/requests/loginReq'
import { useTranslation } from "react-i18next";
import SettingsDropDown from '../../../UI/SettingsDropDown/SettingsDropDown'//SettingsDropDown
import SettingsTextBox from '../../../UI/SettingsTextBox/SettingsTextBox'
import { DropdownButton, Dropdown, Button } from 'react-bootstrap'
import AlertContext from '../../../../context/AlertModelContext/AlertModalContext'

const CallBackSettings = (props) => {
    const selectedProjectStateDefault = 'Create new project'
    const selectedProjectDeviceOrAgentStateDefault = 'Add new device/agent to ptoject'
    const [t] = useTranslation('common')
    const [selectedProjectState, setSelectedProjectState] = useState(selectedProjectStateDefault)
    const [selectedProjectEditableState, setSelectedProjectEditableState] = useState('')
    const [selectedProjectTypeState, setSelectedProjectTypeState] = useState('ITC')
    const [selectedProjectUrlState, setSelectedProjectUrlState] = useState('')
    const [selectedProjectDeviceOrAgents, setSelectedProjectDeviceOrAgents] = useState([])
    const [selectedProjectDeviceOrAgentState, setSelectedProjectDeviceOrAgentState] = useState(selectedProjectDeviceOrAgentStateDefault)
    const [projectDeviceOrAgentInputState, setProjectDeviceOrAgentInputState] = useState('')
    const alertCtx = useContext(AlertContext)

    const callBackProjects = props.callBackSetting.callBackProjects
    const setSettings = props.setSettings
    const setSaveAndRestartBtnActiveState = props.setSaveAndRestartBtnActiveState
    //useCallbacks
    const setSettingsMiddleware = useCallback((settingType, settingName, value) => {
        setSettings(settingType, settingName, value)
        setSaveAndRestartBtnActiveState(true)
    }, [setSettings, setSaveAndRestartBtnActiveState])
    const onProjectSelect = useCallback((settingType, settingName, project) => {
        if (project !== selectedProjectStateDefault) {
            const projectObj = callBackProjects.find(callBackProject => callBackProject.project === project)
            if (projectObj) {
                setSelectedProjectTypeState(projectObj.projectType)
                setSelectedProjectUrlState(projectObj.url)
                setSelectedProjectDeviceOrAgents(projectObj.subscribers)
                setSelectedProjectDeviceOrAgentState(selectedProjectDeviceOrAgentStateDefault)
            }
            else {
                return
            }
            setSelectedProjectEditableState(project)
        }
        else {
            setSelectedProjectTypeState('ITC')
            setSelectedProjectUrlState('')
            setSelectedProjectEditableState('')
            setSelectedProjectDeviceOrAgents([])
            setSelectedProjectDeviceOrAgentState(selectedProjectDeviceOrAgentStateDefault)
            setProjectDeviceOrAgentInputState('')
        }

        setSelectedProjectState(project)

    }, [callBackProjects])

    const onProjectNameInputChange = useCallback((event) => {
        setSelectedProjectEditableState(event.target.value)
    }, [])

    const onProjectTypeSelect = useCallback((projectType) => {
        setSelectedProjectTypeState(projectType)
    }, [])

    const onProjectUrlChange = useCallback((event) => {
        setSelectedProjectUrlState(event.target.value)
    }, [])

    const onProjectDeviceOrAgentSelected = useCallback((deviceOrAgent) => {
        setSelectedProjectDeviceOrAgentState(deviceOrAgent)
        setProjectDeviceOrAgentInputState('')
    }, [])

    const onProjectSaveClick = useCallback(() => {
        if (selectedProjectState === selectedProjectStateDefault) {//save
            setSettingsMiddleware('callBack', 'saveCallBackProject', { projectType: selectedProjectTypeState, url: selectedProjectUrlState, project: selectedProjectEditableState, subscribers: [] })
        }
        else {//update
            setSettingsMiddleware('callBack', 'updateCallBackProject', { projectType: selectedProjectTypeState, url: selectedProjectUrlState, project: selectedProjectEditableState, searchProject: selectedProjectState })
        }
        // setTimeout(()=>onProjectSelect(undefined,undefined,selectedProjectEditableState),1000)
        setTimeout(() => onProjectSelect(undefined, undefined, selectedProjectStateDefault), 0)
    }, [onProjectSelect, selectedProjectEditableState, selectedProjectState, selectedProjectTypeState, selectedProjectUrlState, setSettingsMiddleware])

    const onProjectRemoveClick = useCallback(() => {
        if (selectedProjectState === selectedProjectStateDefault) {
            return alertCtx.showAlert(t('error'), t('Please select project'), 'sm')
            //return alert(t('Please select project'))
        }
        setSettingsMiddleware('callBack', 'removeCallBackProject', selectedProjectState)
        setTimeout(() => onProjectSelect(undefined, undefined, selectedProjectStateDefault), 0)

    }, [t, selectedProjectState, setSettingsMiddleware, onProjectSelect, alertCtx])

    const onChangeProjectDeviceOrAgentInput = useCallback((event) => {
        setProjectDeviceOrAgentInputState(event.target.value)
    }, [])

    const onClickAgentOrDeviceRemove = useCallback(() => {
        setSettingsMiddleware('callBack', 'removeCallBackProjectSubscribers', { project: selectedProjectState, subscriber: selectedProjectDeviceOrAgentState })
        setTimeout(() => onProjectSelect(undefined, undefined, selectedProjectState), 0)

    }, [setSettingsMiddleware, selectedProjectState, selectedProjectDeviceOrAgentState, onProjectSelect])

    const onClickAgentOrDeviceSave = useCallback(() => {
        setSettingsMiddleware('callBack', 'saveCallBackProjectSubscribers', { project: selectedProjectState, subscriber: projectDeviceOrAgentInputState })
        setTimeout(() => onProjectSelect(undefined, undefined, selectedProjectState), 0)
        setTimeout(() => setSelectedProjectDeviceOrAgentState(projectDeviceOrAgentInputState), 0)
        setTimeout(() => setProjectDeviceOrAgentInputState(''), 0)
    }, [projectDeviceOrAgentInputState, selectedProjectState, setSettingsMiddleware, onProjectSelect])




    let callBackProjectItems = props.callBackSetting.callBackProjects.map(project => project.project)
    callBackProjectItems = [selectedProjectStateDefault, ...callBackProjectItems]
    const isCallBackEnableList = [true, false]
    const addCallBacksWhenDialerOpen = [true, false]
    const deleteAllCallbacksFromDialListWhenUserLogout = [true,false]
    const projectTypes = ['ITC']

    const projectTypesdropDownItems = projectTypes.map((projectType, i) => {
        return <Dropdown.Item key={i} onClick={() => onProjectTypeSelect(projectType)} className={styles.specificSettingsDropDownItem}>{projectType}</Dropdown.Item>
    })

    let projectSubscribersList = undefined
    if (selectedProjectDeviceOrAgents.length > 0) {
        projectSubscribersList = selectedProjectDeviceOrAgents.map((DeviceOrAgent, i) => {
            return (
                <Dropdown.Item key={i} onClick={() => onProjectDeviceOrAgentSelected(DeviceOrAgent)} className={styles.specificSettingsDropDownItem}>{DeviceOrAgent}</Dropdown.Item>
            )
        })
        projectSubscribersList = [<Dropdown.Item key={999} onClick={() => onProjectDeviceOrAgentSelected(selectedProjectDeviceOrAgentStateDefault)} className={styles.specificSettingsDropDownItem}>{t(selectedProjectDeviceOrAgentStateDefault)}</Dropdown.Item>
            , ...projectSubscribersList]
        //todo
    }
    let projectManagementPanel = undefined

    // if(selectedProjectState===selectedProjectStateDefault){
    projectManagementPanel = <section className={styles.projectManagementPanelSection}>
        <h2 className={styles.settingsTitle}>{t('projectManagment')}</h2>
        <div className={styles.someSettingDiv}>
            <span className={styles.specificSettingsText}>{t('projectName')} </span>
            <input type='text' value={selectedProjectEditableState} onChange={onProjectNameInputChange} className={styles.projectName} />
        </div>
        <div className={styles.someSettingDiv}>
            <span className={styles.specificSettingsText}>{t('projectType')} </span>
            <DropdownButton className={styles.specificSettingsDropDown} variant='secondary' title={selectedProjectTypeState}>
                {projectTypesdropDownItems}
            </DropdownButton>
        </div>
        <div className={styles.someSettingDiv}>
            <span className={styles.specificSettingsText}>{t('projectUrl')} </span>
            <textarea value={selectedProjectUrlState} onChange={onProjectUrlChange} className={styles.projecturl} />
        </div>
        {selectedProjectState !== selectedProjectStateDefault &&
            <Fragment>
                <div className={styles.someSettingDiv}>
                    <span className={styles.specificSettingsText}>{t('projectAgents')} </span>
                    <DropdownButton className={styles.specificSettingsDropDown} variant='secondary' title={t(selectedProjectDeviceOrAgentState)}>
                        {projectSubscribersList}

                    </DropdownButton>

                </div>
                <div className={styles.saveRemoveProjectAgentDiv}>
                    {selectedProjectDeviceOrAgentStateDefault === selectedProjectDeviceOrAgentState ?
                        <Fragment>
                            <input type='text' className={styles.subscriberTextInput} onChange={onChangeProjectDeviceOrAgentInput} value={projectDeviceOrAgentInputState} />
                            <Button variant='success' onClick={onClickAgentOrDeviceSave} >{t('save')}</Button>
                        </Fragment>
                        :
                        <Button variant='danger' onClick={onClickAgentOrDeviceRemove}>{t('remove')}</Button>
                    }

                </div>
            </Fragment>
        }
    </section>


    return (
        <section className={styles.SettingsSection}>
            <h2 className={styles.settingsTitle}>{t('callBackSettings')}</h2>
            <SettingsDropDown nowSelected={props.callBackSetting.isEnable} setSettings={setSettingsMiddleware} settingType={'callBack'} label={'isCallBackEnable'} settingName={'isEnable'} items={isCallBackEnableList} />
            <SettingsDropDown nowSelected={props.callBackSetting.addCallBacksWhenDialerOpen} setSettings={setSettingsMiddleware} settingType={'callBack'} label={'addCallBacksWhenDialerOpen'} settingName={'addCallBacksWhenDialerOpen'} items={addCallBacksWhenDialerOpen} />
            <SettingsDropDown nowSelected={props.callBackSetting.deleteAllCallbacksFromDialListWhenUserLogout} setSettings={setSettingsMiddleware} settingType={'callBack'} label={'deleteAllCallbacksFromDialListWhenUserLogout'} settingName={'deleteAllCallbacksFromDialListWhenUserLogout'} items={deleteAllCallbacksFromDialListWhenUserLogout} />
            <SettingsTextBox type='text' nowValue={props.callBackSetting.everySecToCheck} id='everySecToCheck' setSettings={setSettingsMiddleware} settingType={'callBack'} settingName={'everySecToCheck'} label={'CallBackEverySecToCheck'} />

            <h2 className={styles.settingsTitle}>{t('callBackProjectSettings')}</h2>
            <SettingsDropDown nowSelected={selectedProjectState} setSettings={onProjectSelect} settingType={'callBack'} label={'selectCallBackProject'} settingName={'selectCallBackProject'} items={callBackProjectItems} />
            <div className={styles.saveRemoveProjectDiv}>
                <Button className={styles.updateAutoMsgTimeClicked} variant='success' onClick={onProjectSaveClick} >{t('save')}</Button>
                {
                    selectedProjectState !== selectedProjectStateDefault &&
                    <Button className={styles.updateAutoMsgTimeClicked} variant='danger' onClick={onProjectRemoveClick}>{t('remove')}</Button>
                }
            </div>
            {projectManagementPanel}
        </section >
    )
}

export default CallBackSettings
